import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  ReactNode,
} from 'react';
import { LocalStorageKeys } from 'src/enums';
import { useDefaultUser } from 'src/hooks';

const UserIdContext = createContext<
  | {
      userId: string | null;
      setUserId: React.Dispatch<React.SetStateAction<string | null>>;
    }
  | undefined
>(undefined);

interface UserProviderProps {
  children: ReactNode;
}

export const UserIdProvider: React.FC<UserProviderProps> = ({ children }) => {
  const { defaultUser } = useDefaultUser();

  const [userId, setUserId] = useState<string | null>(() => {
    const storedUserId = localStorage.getItem(LocalStorageKeys.USER_ID);
    return storedUserId;
  });

  useEffect(() => {
    localStorage.setItem(
      LocalStorageKeys.USER_ID,
      userId ?? defaultUser?.userId ?? ''
    );
  }, [userId, defaultUser]);

  return (
    <UserIdContext.Provider value={{ userId, setUserId }}>
      {children}
    </UserIdContext.Provider>
  );
};

export const useUserId = () => {
  const context = useContext(UserIdContext);
  if (!context) {
    throw new Error('useUserId must be used within a UserProvider');
  }
  return context;
};
